/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2024 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/
import * as React from "react";
import infoIconUrl from "./images/info.svg";
import { SWCTooltip } from "components/shared/Tooltips";
import { devices, fontFamilies, useIsMobile } from "components/shared/Styles";
import styled from "styled-components";
import { Placement } from "@spectrum-web-components/overlay/src/overlay-types";

const Heading = styled.h2`
  font: normal normal 900 22px/27px ${fontFamilies};
  color: var(--spectrum-global-color-gray-900);
  text-align: center;
`;

const Container = styled.span`
  display: flex;
  flex-direction: row;
  padding: 0 5px;
  ${devices.small} {
    justify-content: center;
  }
`;

const InfoIconImg = styled.img`
  ${devices.medium} {
    margin-left: 10px;
    margin-right: 10px;
  }
`;

export const InfoContainer: React.FC = () => {
  const isMobile = useIsMobile();
  const fileInstructionsText = isMobile
    ? I18n.t("enhance_speech.choose_files_instruction")
    : I18n.t("enhance_speech.premium.drop_files_instruction");

  return (
    <Container>
      <Heading>{fileInstructionsText}</Heading>
    </Container>
  );
};

interface InfoIconProps {
  placement?: Placement;
  children?: React.ReactNode;
}

export const InfoIcon: React.FC<InfoIconProps> = ({
  placement = "bottom",
  children,
}) => {
  return (
    <overlay-trigger
      style={{ display: "flex", alignItems: "center", justifyItems: "center" }}
    >
      <InfoIconImg src={infoIconUrl} slot="trigger" alt="" />
      <SWCTooltip slot="hover-content" placement={placement} open>
        {children}
      </SWCTooltip>
    </overlay-trigger>
  );
};
